export default __webpack_public_path__ + "static/media/img-0659-lithuania-half-face.32109631.png";